import { Button } from "@kitbird/core";
import { ColumnI } from "../../../../../components/Table/TableProps";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/trash.svg";
import Table from "../../../../../components/Table";
import DetailUserAccount from "../DetailUserAccount/DetailUserAccount";
import { IUserAccount } from "../../../../../services/userAccountService";

interface UserAccountTableProps {
  onActionClick: {
    delete: (data: IUserAccount) => void;
  };
  dataSource: IUserAccount[];
  footer: React.ReactNode;
}

const UserAccountTable = ({ onActionClick, dataSource, footer }: UserAccountTableProps) => {
  const columns: ColumnI[] = [
    {
      title: "Detail user",
      dataIndex: "id",
      key: "id",
      width: "85%",
      render: (_, row) => (
        <DetailUserAccount
          userEmail={row.employee_email}
          userName={row.employee_name}
          userNip={row.employee_id}
          showNip
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "employee_id",
      key: "employee_id",
      render: (item, row) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            style={{ padding: "8px 10px" }}
            backgroundColor={"rgb(203, 91, 75)"}
            onClick={() => onActionClick.delete(row as IUserAccount)}
            data-testid="delete-user-account-btn"
          >
            <TrashIcon width={16} height={16} />
          </Button>
        </div>
      ),
    },
  ];
  return <Table withNumber columns={columns} dataSource={dataSource} footer={footer} />;
};

export default UserAccountTable;
